import moment from 'moment-timezone';

const getUtcDate = (date: Date, format = '') => {
  const utcDate = moment(date).utc();
  return format ? utcDate.format(format) : utcDate.format();
};

const formatInTimeZone = (date: Date | string, format: string, timezone = Intl.DateTimeFormat().resolvedOptions().timeZone) => moment(new Date(date)).tz(timezone).format(format);

const formatDateFormat = (date: string | Date, format: string) => moment(new Date(date)).format(format);

const addDays = (date: string | Date, limit: number, unit: 'days' | 'hours' = 'days') => moment(new Date(date)).add(limit, unit).toDate();

const subtractDays = (date: string | Date, limit: number, unit: 'days' | 'hours') => moment(new Date(date)).subtract(limit, unit).toDate();

const calculateDateTimeDifference = (start: Date | string, difference: number, days = false) => days ? subtractDays(start, difference, 'days') : subtractDays(start, difference, 'hours');

const isApptEditable = (appointmentStartTime: Date | string, isFromFeedAppointment: boolean, customerCanScheduleAppointment: boolean) => {
  const defaultPeriod = process.env.VUE_APP_DEFAULT_APPOINTMENT_PERIOD;
  const minDate = calculateDateTimeDifference(appointmentStartTime, +defaultPeriod);
  return (new Date() < minDate) && !isFromFeedAppointment && customerCanScheduleAppointment;
};

export {
  getUtcDate, formatInTimeZone, formatDateFormat, calculateDateTimeDifference, isApptEditable, addDays
}
